const shouldUseFamilyNameFirst = (language: string) => {
  const normalized = (language || '').toLowerCase();
  return normalized.startsWith('ja') || normalized.startsWith('zh') || normalized.startsWith('ko');
};

export const formatUserName = (
  firstName?: string | null,
  lastName?: string | null,
  language: string = 'ja'
) => {
  const first = (firstName || '').trim();
  const last = (lastName || '').trim();

  if (!first && !last) {
    return '';
  }

  return shouldUseFamilyNameFirst(language)
    ? `${last} ${first}`.trim()
    : `${first} ${last}`.trim();
};

/** サンプル作製者表示（氏名 → username → creatorDisplayName） */
export function formatSampleCreatorLabel(
  sample: {
    user?: {
      firstName?: string | null;
      lastName?: string | null;
      username?: string | null;
    } | null;
    creatorDisplayName?: string | null;
  },
  language: string
): string {
  const formatted = sample.user
    ? formatUserName(sample.user.firstName, sample.user.lastName, language)
    : '';
  return formatted || sample.user?.username || sample.creatorDisplayName || '-';
}
